module.exports = __webpack_public_path__ + "static/media/private.81d0bac3.png";